import { Box } from "@mui/material";
import { Asset } from "../../models/Asset";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";

import * as THREE from "three";
import { useState } from "react";

export interface AssetDescriptionProps {
  asset: Asset;
  model: THREE.Object3D | null;
  setAsset?: (asset: Asset) => void;
}

function createTreeItems(obj: THREE.Object3D, onClick: any): JSX.Element[] {
  const items: any[] = [];
  for (const child of obj.children) {
    const treeItem = {
      id: `${child.id}`,
      name: `${child.name} (${child.type})`,
      children: child.children,
      object: child,
    };
    items.push(treeItem);
    // if (child instanceof THREE.Group) {
    //   treeItem.children = createTreeItems(child, onClick);
    // }
  }
  return items.map((item) => (
    <TreeItem
      key={item.id}
      itemId={item.id}
      onClick={() => onClick(item)}
      label={item.name}
    >
      {item.children && createTreeItems(item.object, onClick)}
    </TreeItem>
  ));

}

export function AssetModelTreeView({ asset, model }: AssetDescriptionProps) {
  const [selected, setSelected] = useState<THREE.Object3D|null>(null);
  const [selectedPreviousMaterial, setSelectedPreviousMaterial] = useState<THREE.Material|THREE.Material[]|null>(null);
  const onItemClick = (item: any) => {
    if (model) {
      if (selected) {
        if (selectedPreviousMaterial) {
          const selectedMesh = selected as THREE.Mesh;
          if (selectedMesh.material) {
            if (Array.isArray(selectedMesh.material)) {
              selectedMesh.material.forEach((mat) => {
                if (mat !== selectedPreviousMaterial) {
                  mat.dispose();
                }
              });
            } else {
              selectedMesh.material.dispose();
            }
            selectedMesh.material = selectedPreviousMaterial;
          }
        }
        setSelected(null);
      }
      const selectedObject = model.getObjectById(parseInt(item.id)) as THREE.Object3D;
      if (selectedObject.type === "Mesh") {
        const mesh = selectedObject as THREE.Mesh;
        setSelected(selectedObject);
        if (mesh.material) {
          setSelectedPreviousMaterial(mesh.material);
          mesh.material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
        }
      }
    }
  };
  if (!model) {
    return <div>Loading...</div>;
  }

  return (
    <Box sx={{ width: '100%', height: "100%", overflow: "auto", background: "#2F2F2F" }}>
      <SimpleTreeView >
        {createTreeItems(model, onItemClick)}
      </SimpleTreeView>
    </Box>
  );
}